import { render } from "./Fellowship.vue?vue&type=template&id=59225ac0&scoped=true"
import script from "./Fellowship.vue?vue&type=script&lang=js"
export * from "./Fellowship.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hanssagita/Documents/freelance/gunsa2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59225ac0"]])

export default __exports__